import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { SoundWave } from './SoundWave';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-white" data-id="element-73">
      <SoundWave data-id="element-74" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full grid lg:grid-cols-2 gap-10 lg:gap-12 items-center py-10 lg:py-0" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-2xl order-2 lg:order-1" data-id="element-76">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.05] mb-6 text-zinc-900" data-id="element-77">
            Danger has a sound.
            <br data-id="element-78" />
            <span className="text-peoplecall" data-id="element-79">We recognize it.</span>
          </h1>

          <p className="text-lg md:text-xl text-zinc-600 mb-8 leading-relaxed max-w-xl" data-id="element-80">
            Peoplecall Pod detects threats in real time — fights, gunshots,
            screams, and distress calls — and sends an instant alert to your
            alarm center. All autonomously. All locally.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-81">
            <Button size="lg" className="group" data-id="element-82">
              Request a Free Demo
            </Button>
            <span className="text-sm text-zinc-500 font-medium" data-id="element-83">
              No commitment. See it live in your environment.
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative order-1 lg:order-2" data-id="element-84">
          <div className="absolute inset-0 bg-peoplecall/10 blur-[100px] rounded-full" data-id="element-85" />
          <img src="https://cdn.magicpatterns.com/uploads/b29Wxra4FYMFMwrKSyKbrw/hero.png" alt="Peoplecall Pod ceiling-mounted microphone in a real environment" className="relative z-10 w-full h-auto object-cover rounded-2xl border border-zinc-200 shadow-xl" data-id="element-86" />

          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -bottom-6 -left-6 bg-white border border-zinc-200 p-4 rounded-xl shadow-xl z-20 flex items-center gap-3" data-id="element-87">
            <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse" data-id="element-88" />
            <span className="text-sm font-medium text-zinc-700" data-id="element-89">
              System active
            </span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}